import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative pt-12 md:pt-20 pb-10 md:pb-16 px-5 md:px-8 max-w-3xl mx-auto text-center" data-id="element-64">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} data-id="element-65">
        <span className="inline-block text-muted-blue font-medium tracking-wide uppercase text-xs md:text-sm mb-4 md:mb-6" data-id="element-66">
          For solo moms running on empty
        </span>

        <h1 className="sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-charcoal mb-6 md:mb-8 text-[32px]" data-id="element-67">
          A 14‑day reset for moms who can't hear themselves think.
        </h1>

        <div className="my-8 md:my-12 relative rounded-xl overflow-hidden shadow-xl border-4 border-white md:rotate-1 md:hover:rotate-0 transition-transform duration-500 max-w-sm sm:max-w-md md:max-w-lg mx-auto" data-id="element-68">
          <img src="https://cdn.magicpatterns.com/uploads/bdWNgUS3azRHSFPzzAQLb3/8CED35F7-99B2-46D0-AA0E-6FD4DFCD82DE.png" alt="The 14-Day Quiet House Reset on a tablet, showing a mother and children" className="w-full h-auto" data-id="element-69" />
        </div>

        <div className="text-left max-w-2xl mx-auto" data-id="element-70">
          <p className="text-lg sm:text-xl md:text-2xl font-serif italic text-charcoal/80 mb-6 md:mb-8 leading-relaxed" data-id="element-71">
            There's a kind of tired that sleep doesn't fix.
          </p>

          <p className="mb-3 md:mb-4 text-base md:text-lg" data-id="element-72">
            It's the tired from:
          </p>
          <ul className="list-none space-y-1.5 md:space-y-2 pl-4 border-l-2 border-muted-blue/30 mb-6 md:mb-8 text-base md:text-lg" data-id="element-73">
            <li data-id="element-74">• Constant noise</li>
            <li data-id="element-75">• Constant mess</li>
            <li data-id="element-76">• Constant demands</li>
            <li data-id="element-77">
              • And never being able to finish one thought before someone needs
              something.
            </li>
          </ul>

          <p className="mb-4 md:mb-6 text-base md:text-lg" data-id="element-78">
            And then you hear your voice get sharp.
          </p>

          <p className="mb-6 md:mb-8 font-medium text-base md:text-lg" data-id="element-79">
            Not because you're a bad mom—because your nervous system has been on
            overtime for months.
          </p>

          <p className="text-base md:text-lg" data-id="element-80">
            This isn't another "routine chart" you'll abandon.
          </p>

          <p className="text-base md:text-lg mt-3 md:mt-4" data-id="element-81">
            This is a 14‑day installation of{' '}
            <strong className="text-muted-blue" data-id="element-82">
              Friction‑Locking Routines
            </strong>
            : three tiny anchors that remove decisions at the exact moments your
            house gets loud.
          </p>

          <div className="mt-8 md:mt-12 text-center" data-id="element-83">
            <a href="#checkout" onClick={e => {
            e.preventDefault();
            const target = document.getElementById('checkout');
            if (!target) return;
            const start = window.scrollY;
            const end = target.getBoundingClientRect().top + window.scrollY - 20;
            const duration = 2000;
            const startTime = performance.now();
            const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
            const animate = (currentTime: number) => {
              const elapsed = currentTime - startTime;
              const progress = Math.min(elapsed / duration, 1);
              window.scrollTo(0, start + (end - start) * easeInOutCubic(progress));
              if (progress < 1) requestAnimationFrame(animate);
            };
            requestAnimationFrame(animate);
          }} className="group inline-flex items-center justify-center gap-3 bg-muted-blue hover:bg-muted-blue-dark text-white text-base md:text-lg font-bold w-full sm:w-auto px-6 md:px-8 py-4 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5" data-id="element-84">
              Start Day 0 Tonight —{' '}
              <span className="line-through opacity-60 text-sm md:text-base font-normal" data-id="element-85">
                $27
              </span>{' '}
              $6.36
            </a>
          </div>
        </div>
      </motion.div>
    </section>;
}